import ArticleCard from "@/components/feature/ArticleCard";
import type { Article } from "@/mocks/articles";

export default function ArticleRelated({ items }: { items: Article[] }) {
  if (items.length === 0) return null;

  return (
    <section aria-label="相关推荐" className="mt-14 border-t border-background-200 pt-10">
      <h2 className="flex items-center gap-2 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
        <span className="h-5 w-1 bg-primary-500"></span>
        相关推荐
      </h2>
      <p className="mt-2 text-sm text-foreground-600">与本文事件脉络相近的深扒内容，建议一并阅读。</p>
      <div className="mt-6 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {items.map((item) => (
          <ArticleCard key={item.id} article={item} />
        ))}
      </div>
    </section>
  );
}